import Text from "consumer/custom/text"
import Button from "consumer/custom/button"
import { useNavigate } from "react-router"
import { get_apply_list } from "../@@@/get_apply_list"


export default function Search() {

    const navigate = useNavigate()

    async function search_apply() {
        const student_name = document.getElementsByName('student_name')[0].value.trim()
        const parent_phone = document.getElementsByName('parent_phone')[0].value.trim()

        if(student_name === '') {
            alert('학생 이름을 입력해 주세요.')
        }
        else if(parent_phone === '') {
            alert('보호자 연락처를 입력해 주세요.')
        }
        else {
            const data = await get_apply_list({
                student_name: student_name,
                parent_phone: parent_phone
            })

            if(data['status'] === 'fail') {
                alert(data['message'])
            }
            else if(data['status'] === 'success') {
                navigate("list", {
                    state: {
                        student_name: student_name,
                        parent_phone: parent_phone
                    }
                })
            }
        }
    }

    return(
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "10px",
                marginTop: "50px",
                boxSizing: "border-box"
            }}
        >
            <Text
                label="학생 이름"
                name="student_name"
                max={20}
                error="학생 이름을 입력해 주세요."
                event={{
                    onInput: function(e) {
                        const value = e.currentTarget.value
                        e.currentTarget.value = value.replace(' ', '')
                    }
                }}
            ></Text>

            <Text
                label="보호자 연락처"
                name="parent_phone"
                max={11}
                error="보호자 연락처를 입력해 주세요."
                event={{
                    onInput: function(e) {
                        const value = e.currentTarget.value
                        e.currentTarget.value = value.replace(/[^0-9]/g, '')
                    }
                }}
            ></Text>

            <Button
                text="확인"
                event={{
                    onClick: function(e) {
                        search_apply()
                    }
                }}
            ></Button>
        </div>
    )
}